import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'selected-billets-panel',
    templateUrl: './selected-billets-panel.component.html',
    styleUrls: ['./selected-billets-panel.component.scss'],
})
export class SelectedBilletsPanelComponent {
    @Input() count = 0;
    @Input() total = 0;
    @Input() disabled = false;
    @Output() confirm = new EventEmitter<void>();
}
